module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0033.jpg?v=9b506703";